module.exports = __webpack_public_path__ + "img/icon-copy-clip.a2e13cff.svg";